import LessonSummaryApiUtils from '../utils/api/lessonSummary';
import { toast } from '@lb-classroom/ui';

export const FETCH_LESSON_SUMMARY_SENT = 'FETCH_LESSON_SUMMARY_SENT';
export const FETCH_LESSON_SUMMARY_SUCCEEDED = 'FETCH_LESSON_SUMMARY_SUCCEEDED';
export const FETCH_LESSON_SUMMARY_FAILED = 'FETCH_LESSON_SUMMARY_FAILED';
export const CREATE_LESSON_SUMMARY_SENT = 'CREATE_LESSON_SUMMARY_SENT';
export const CREATE_LESSON_SUMMARY_SUCCEEDED =
  'CREATE_LESSON_SUMMARY_SUCCEEDED';
export const CREATE_LESSON_SUMMARY_FAILED = 'CREATE_LESSON_SUMMARY_FAILED';
export const UPDATE_LESSON_SUMMARY_SENT = 'UPDATE_LESSON_SUMMARY_SENT';
export const UPDATE_LESSON_SUMMARY_SUCCEEDED =
  'UPDATE_LESSON_SUMMARY_SUCCEEDED';
export const UPDATE_LESSON_SUMMARY_FAILED = 'UPDATE_LESSON_SUMMARY_FAILED';
export const CLEAR_LESSON_SUMMARY_DATA = 'CLEAR_LESSON_SUMMARY_DATA';

export function clearData() {
  return {
    type: CLEAR_LESSON_SUMMARY_DATA,
  };
}

export function fetchOneSent() {
  return { type: FETCH_LESSON_SUMMARY_SENT };
}

export function fetchOneSucceeded(data) {
  return {
    type: FETCH_LESSON_SUMMARY_SUCCEEDED,
    payload: data,
  };
}

export function fetchOneFailed(error) {
  return {
    type: FETCH_LESSON_SUMMARY_FAILED,
  };
}

export function fetchOne(id) {
  return (dispatch) => {
    return LessonSummaryApiUtils.fetchOne(id).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}

export function fetchOneByLessonId(id) {
  return (dispatch) => {
    dispatch(fetchOneSent());
    return LessonSummaryApiUtils.fetchOneByLessonId(id).then(
      (data) => dispatch(fetchOneSucceeded(data)),
      (error) => dispatch(fetchOneFailed(error)),
    );
  };
}

export function createSent() {
  return { type: CREATE_LESSON_SUMMARY_SENT };
}

export function createSucceeded(data) {
  return {
    type: CREATE_LESSON_SUMMARY_SUCCEEDED,
    payload: data,
  };
}

export function createFailed(error) {
  return { type: CREATE_LESSON_SUMMARY_FAILED };
}

export function create(lessonId, params) {
  return (dispatch) => {
    dispatch(createSent());
    return LessonSummaryApiUtils.create(lessonId, params).then(
      (data) => {
        toast.success('Successfully created the summary.');
        dispatch(createSucceeded(data));
      },
      (error) => {
        toast.error(error.message || 'Failed to create the summary.');
        dispatch(createFailed(error));
      },
    );
  };
}

export function updateSent() {
  return { type: UPDATE_LESSON_SUMMARY_SENT };
}

export function updateSucceeded(data) {
  return {
    type: UPDATE_LESSON_SUMMARY_SUCCEEDED,
    payload: data,
  };
}

export function updateFailed(error) {
  return { type: UPDATE_LESSON_SUMMARY_FAILED };
}

export function update(lessonId, params) {
  return (dispatch) => {
    dispatch(updateSent());
    return LessonSummaryApiUtils.update(lessonId, params).then(
      (data) => {
        toast.success('Successfully updated the summary.');
        dispatch(updateSucceeded(data));
      },
      (error) => {
        toast.error(error.message || 'Failed to update the summary.');
        dispatch(updateFailed(error));
      },
    );
  };
}
